import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BDiseaseTagFetchListCard } from './BDiseaseTagFetchListCard'

export const BDiseaseTagPopperListCard = defineComponent({
  name: 'BDiseaseTagPopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids }} tippyConfig={getAsyncListTippyConfig()} component={BDiseaseTagFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
